import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  ScrollView,
  TouchableOpacity,
  Linking,
  Alert,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../utils/colors';
import { typography } from '../utils/typography';
import { spacing } from '../utils/theme';

export const AboutScreen: React.FC = () => {
  const navigation = useNavigation();
  const handleOpenLink = async (url: string, title: string) => {
    try {
      const supported = await Linking.canOpenURL(url);
      if (supported) {
        await Linking.openURL(url);
      } else {
        Alert.alert('エラー', `${title}を開けませんでした`);
      }
    } catch (error) {
      console.error('Open link error:', error);
      Alert.alert('エラー', `${title}を開けませんでした`);
    }
  };

  const handleLicenses = () => {
    Alert.alert('オープンソースライセンス', '今後実装予定');
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity 
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color={colors.text} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>アプリについて</Text>
        <View style={styles.headerSpacer} />
      </View>

      <ScrollView>
        {/* アプリ情報セクション */}
        <View style={styles.appInfoSection}>
          <View style={styles.appIcon}>
            <Ionicons name="logo-twitter" size={64} color={colors.primary} />
          </View>
          <Text style={styles.appName}>Pixelsky</Text>
          <Text style={styles.appVersion}>バージョン 0.1.0 (Beta)</Text>
          <Text style={styles.appDescription}>
            Twitter風のUIで動作するBlueskyクライアント
          </Text>
        </View>

        {/* 開発情報セクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>開発情報</Text>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>開発者</Text>
            <Text style={styles.infoValue}>Your Name</Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>フレームワーク</Text>
            <Text style={styles.infoValue}>React Native (Expo)</Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>プロトコル</Text>
            <Text style={styles.infoValue}>AT Protocol (Bluesky)</Text>
          </View>
        </View>

        {/* リンクセクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>リンク</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              handleOpenLink('https://bsky.app', 'Bluesky公式サイト')
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="globe-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>Bluesky公式サイト</Text>
            </View>
            <Ionicons
              name="open-outline"
              size={20}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              handleOpenLink(
                'https://github.com/bluesky-social/atproto',
                'AT Protocolリポジトリ'
              )
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="logo-github" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>AT Protocolリポジトリ</Text>
            </View>
            <Ionicons
              name="open-outline"
              size={20}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              Alert.alert('プライバシーポリシー', '今後実装予定')
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="document-text-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>プライバシーポリシー</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              Alert.alert('利用規約', '今後実装予定')
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="document-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>利用規約</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity style={styles.option} onPress={handleLicenses}>
            <View style={styles.optionLeft}>
              <Ionicons name="code-slash-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>オープンソースライセンス</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>

        {/* フィードバックセクション */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>フィードバック</Text>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              Alert.alert('フィードバック', '今後実装予定')
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="chatbubble-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>フィードバックを送信</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.option}
            onPress={() =>
              Alert.alert('バグ報告', '今後実装予定')
            }
          >
            <View style={styles.optionLeft}>
              <Ionicons name="bug-outline" size={22} color={colors.textSecondary} />
              <Text style={styles.optionLabel}>バグを報告</Text>
            </View>
            <Ionicons
              name="chevron-forward"
              size={22}
              color={colors.textSecondary}
            />
          </TouchableOpacity>
        </View>

        {/* コピーライトセクション */}
        <View style={styles.copyrightSection}>
          <Text style={styles.copyrightText}>
            © 2026 Pixelsky. All rights reserved.
          </Text>
          <Text style={styles.copyrightText}>
            Built with ❤️ for the Bluesky community
          </Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
    backgroundColor: colors.background,
  },
  backButton: {
    padding: 4,
    width: 32,
  },
  headerTitle: {
    ...typography.h2,
    color: colors.text,
    flex: 1,
    textAlign: 'center',
  },
  headerSpacer: {
    width: 32,
  },
  appInfoSection: {
    alignItems: 'center',
    paddingVertical: spacing.xl,
    paddingHorizontal: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  appIcon: {
    width: 96,
    height: 96,
    borderRadius: 20,
    backgroundColor: colors.card,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  appName: {
    ...typography.h2,
    color: colors.text,
    marginBottom: spacing.xs,
  },
  appVersion: {
    ...typography.body,
    color: colors.textSecondary,
    marginBottom: spacing.sm,
  },
  appDescription: {
    ...typography.body,
    color: colors.textSecondary,
    textAlign: 'center',
  },
  section: {
    marginTop: spacing.lg,
    paddingHorizontal: spacing.md,
  },
  sectionTitle: {
    ...typography.h4,
    color: colors.textSecondary,
    marginBottom: spacing.sm,
  },
  infoItem: {
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  infoLabel: {
    ...typography.caption,
    color: colors.textSecondary,
    marginBottom: 4,
  },
  infoValue: {
    ...typography.body,
    color: colors.text,
  },
  option: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  optionLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  optionLabel: {
    ...typography.body,
    color: colors.text,
    marginLeft: spacing.md,
  },
  copyrightSection: {
    alignItems: 'center',
    paddingVertical: spacing.xl,
    paddingHorizontal: spacing.md,
  },
  copyrightText: {
    ...typography.caption,
    color: colors.textSecondary,
    textAlign: 'center',
    marginBottom: spacing.xs,
  },
});
